var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isChild && !this.$route.query.userType
    ? _c(
        "div",
        {
          class:
            _vm.productFlag == 1 ? "platform_jump_btn" : "platform_jump_btn1"
        },
        [
          _vm.buttonShowArr.length
            ? [
                _vm.type == "3" || _vm.type == "7"
                  ? [
                      _vm._l(_vm.buttonShowArr, function(item, index) {
                        return _vm.buttonShowArr.length == 1
                          ? [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "bury",
                                      rawName: "v-bury",
                                      value: { start: true },
                                      expression: "{ start: true }"
                                    }
                                  ],
                                  key: item.index + "_" + index,
                                  class:
                                    _vm.type == "7" ? "trainBtn" : "otherBtn",
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.startFn(
                                        item.platform,
                                        0,
                                        item.index
                                      )
                                    }
                                  }
                                },
                                [_vm._v("业务处理\n          ")]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.buttonShowArr.length > 1
                        ? [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "bury",
                                    rawName: "v-bury",
                                    value: { start: true },
                                    expression: "{ start: true }"
                                  }
                                ],
                                class:
                                  _vm.type == "7" ? "trainBtn" : "otherBtn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.startFn(
                                      _vm.buttonShowArr[0].platform,
                                      0,
                                      0
                                    )
                                  }
                                }
                              },
                              [_vm._v("业务处理\n        ")]
                            )
                          ]
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == "1" || _vm.type == "2"
                  ? [
                      _vm.buttonShowArr[0].platform === "RPAOS"
                        ? _c(
                            "div",
                            {
                              ref: "startSoftware",
                              staticClass: "task_btn",
                              attrs: { href: _vm.startSoftwareUrl },
                              on: {
                                click: function($event) {
                                  return _vm.startIforame($event)
                                }
                              }
                            },
                            [_vm._v("\n          启动RPA\n        ")]
                          )
                        : _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "bury",
                                  rawName: "v-bury",
                                  value: { start: true },
                                  expression: "{ start: true }"
                                }
                              ],
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.startFn(
                                    _vm.buttonShowArr[0].platform
                                  )
                                }
                              }
                            },
                            [_vm._v("开始练习")]
                          )
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    : _vm.childrenBtn.length
    ? _c(
        "div",
        { staticClass: "child_platform_jump_btn" },
        [
          _vm._l(_vm.childrenBtn, function(childSort) {
            return [
              _vm.buttonShowArr[childSort].platform === "RPAOS"
                ? _c(
                    "div",
                    {
                      key: childSort + "child",
                      ref: "startSoftware",
                      refInFor: true,
                      staticClass: "rpa_btn",
                      attrs: { href: _vm.startSoftwareUrl },
                      on: {
                        click: function($event) {
                          return _vm.startIforame($event, childSort)
                        }
                      }
                    },
                    [_vm._v("\n        启动RPA\n      ")]
                  )
                : _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "bury",
                          rawName: "v-bury",
                          value: { start: true },
                          expression: "{ start: true }"
                        }
                      ],
                      key: childSort + "child",
                      staticClass: "btnStyle",
                      on: {
                        click: function($event) {
                          return _vm.startFn(
                            _vm.buttonShowArr[childSort].platform,
                            _vm.buttonShowArr[childSort].platform ===
                              "BigDataOS" ||
                              _vm.buttonShowArr[childSort].platform === "ctx"
                              ? 2
                              : 1,
                            childSort
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.platFromBtn[
                              _vm.buttonShowArr[childSort].platform
                            ] || _vm.buttonShowArr[childSort].platform
                          ) +
                          "\n      "
                      )
                    ]
                  )
            ]
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9f21fe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f21fe8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/platformBtn/trainingNewBtn.vue
// module id = null
// module chunks = 